import { render, staticRenderFns } from "./WebcastVimeo.vue?vue&type=template&id=5e835a7a&scoped=true&"
import script from "./WebcastVimeo.vue?vue&type=script&lang=js&"
export * from "./WebcastVimeo.vue?vue&type=script&lang=js&"
import style0 from "./WebcastVimeo.vue?vue&type=style&index=0&id=5e835a7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e835a7a",
  null
  
)

component.options.__file = "WebcastVimeo.vue"
export default component.exports